module.exports = __webpack_public_path__ + "static/media/dashboard.54857a22.svg";